<template>
    <v-container fluid fill-height>
        <v-layout>
            <v-flex>
                <v-card>
                   <RejectedPunnets :plantID="plantID" />
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { mapActions } from "vuex";

import RejectedPunnets from "@/components/rejections/RejectedPunnets";
 
export default {
    data() {
        return {
            loading: false
        }
    },
    components: {
        RejectedPunnets
    },
    async created() {
        await this.loadInitialData();
    },
    computed: {
        ...mapState("RejectionStore", {
        }),
        ...mapGetters({
          
        }),
        plantID() {
            return this.$route.params.plantID;
        }
    },
    methods: {
        ...mapActions("RejectionStore", [
            "loadMasterData",
            "loadSessions",
            "resetState"
        ]),
       async loadInitialData() {
           try{
               this.loading = true;
               this.resetState();
               await this.loadMasterData(this.plantID);
           } catch(e) {
               this.error = e.toString();
           } finally {  
               this.loading = false;
           }
       }
    },
    watch: {
      
    }
}
</script>

<style>
</style>
